import { Component } from "@angular/core";
import { DraftForm, DraftFormType } from "src/app/modules/ngx-draft";
import { FileType, Mask } from "src/app/components/v-file-upload/file-upload.component";
import { IUserEx } from "@vierkant-software/types__api";
import { IFrontendUser } from "../../contract.interfaces";
import { DARK_LIGHTNESS, LIGHT_LIGHTNESS } from "src/app/components/v-hsl-picker/v-hsl-picker.component";


const DEFAULT_COLOR: [number, number] = [0, 0.75];

@Component({
    templateUrl: './photo.step.haml',
    styleUrls:   ['./photo.step.sass'],
    standalone:  false
})
export class UserPhotoStep {
    private _darkColor?: string;
    private _lightColor?: string;

    @DraftForm() form: DraftFormType<IFrontendUser>;

    public FileType = FileType;
    public Mask = Mask;

    public get hasDefaultColor(): boolean {
        return !!this.form.value.defaultColor;
    }
    public get hasCustomColor(): boolean {
        return !!this.form.value.userColor;
    }
    public set hasCustomColor(value: boolean) {
        this.form.patchValue({userColor: value ? this.form.value.defaultColor ?? DEFAULT_COLOR : null});
    }

    public get darkColor(): string {
        if (this.hasCustomColor) return this._darkColor;
        const [hue, saturation] = this.form.value.defaultColor ?? [0, 0.7];
        return `hsl(${hue}deg, ${saturation * 100}%, ${DARK_LIGHTNESS}%)`;
    }

    public set darkColor(value: string) {
        this._darkColor = value;
    }

    public get lightColor(): string {
        if (this.hasCustomColor) return this._lightColor;
        const [hue, saturation] = this.form.value.defaultColor ?? [0, 0.7];
        return `hsl(${hue}deg, ${saturation * 100}%, ${LIGHT_LIGHTNESS}%)`;
    }

    public set lightColor(value: string) {
        this._lightColor = value;
    }

    public getUser(color: [number, number]): IUserEx {
        return {
            ...this.form.value,
            userColor: color,
        };
    }
}
